import { Button } from "@/types/pages/blocks"
import { Link } from "react-router-dom"
import { resolveNavLink } from "@/utils/navigation"

export interface ImageContentProps {
  title: string | null // HTML
  subtitle: string | null // HTML
  button: Button | null
}

export default function ImageContent({ title, subtitle, button }: ImageContentProps) {
  const resolvedLink = button ? resolveNavLink(button) : { url: '#', isExternal: false }

  return (
    <div className="flex flex-col gap-2 md:gap-3 px-8 py-6 w-full flex-1 items-center md:items-start md:w-fit h-full">
      {title && <div className="text-4xl font-bold text-white text-shadow-md prose prose-invert prose-h1:text-4xl prose-h2:text-3xl max-w-none" dangerouslySetInnerHTML={{ __html: title }} />}
      {subtitle && <div className="text-lg text-white max-w-sm text-shadow-md prose prose-invert prose-p:my-1" dangerouslySetInnerHTML={{ __html: subtitle }} />}
      {button && button.label && (
        <Link
          to={resolvedLink.url}
          target={resolvedLink.isExternal ? '_blank' : '_self'}
          rel={resolvedLink.isExternal ? 'noopener noreferrer' : undefined}
          className="inline-block mt-auto max-w-fit px-6 py-2 bg-primary text-on-primary rounded-md shadow-sm font-medium hover:bg-primary/90 transition-colors">
          {button.label}
        </Link>
      )
      }
    </div>
  )
}